import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { VStack } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { Button, Footer, Header, LogoActionBar, Main, RichText, ScrollContainer, Spinner, } from 'Components/utility';
import { REGISTER_CLEAR } from 'Reducers/register/types';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { updateConsent } from 'Services/consent';
const mapStateToProps = ({ env: { app }, register }) => {
    return {
        app,
        patientId: register.patientId,
    };
};
const connector = connect(mapStateToProps);
const RWEConsent = ({ app, patientId }) => {
    const [loading, setLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const handleSubmitResearchAction = useCallback(async (action) => {
        try {
            setLoading(true);
            const authSession = getAuthSession();
            if (authSession) {
                await updateConsent(patientId, action, app, 'realWorldEvidence', authSession.accessToken);
                mediator.publish('router:navigate', '/login');
                store.dispatch({ type: REGISTER_CLEAR });
                return;
            }
            showApiErrorModal();
        }
        catch {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    }, [app, patientId, showApiErrorModal]);
    const handleLinkClick = (href) => {
        mediator.publish('router:navigate', href);
    };
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { titleTestID: "Research.actionTitle", title: i18n.t('Research.title'), noActionButton: true }),
        loading && React.createElement(Spinner, null),
        React.createElement(ScrollContainer, null,
            React.createElement(Header, { testID: "Research.title", title: i18n.t('Research.title') }),
            React.createElement(VStack, { padding: "$4" },
                React.createElement(RichText, { onPressLink: handleLinkClick, text: i18n.t('Research.content.researchRichText.bodyText') }))),
        React.createElement(Footer, { customProps: React.createElement(VStack, { padding: "$4" },
                React.createElement(Button, { onPress: () => handleSubmitResearchAction('accept'), testID: "RWE.optIn", label: i18n.t('Global.microcopy.common.optIn'), "aria-label": i18n.t('Global.microcopy.common.optIn'), marginBottom: "$4" }),
                React.createElement(Button, { variant: "tertiary", testID: "Global.microcopy.common.decline", label: i18n.t('Global.microcopy.common.decline'), "aria-label": i18n.t('Global.microcopy.common.decline'), onPress: () => handleSubmitResearchAction('decline') })) })));
};
export default connector(RWEConsent);
